import { ErrorNotification } from '@sleepstation/components'
import { paddingTop } from '@sleepstation/style-api-helpers'
import { constrainNarrow } from '@sleepstation/style-mixins'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const TITLE = `We’ve experienced a problem loading this page`
const BODY = `We’ve notified our developers about this problem and they’ll work to resolve it ASAP. If you need any more help, just send us a message and our team will be able to help.`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  ${paddingTop([1])}
  ${constrainNarrow()}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TopLevelErrorNotification = ({ ...props }) => (
  <Layout>
    <ErrorNotification title={TITLE} body={BODY} {...props} />
  </Layout>
)

export default TopLevelErrorNotification
